<template>
    <div id="wx_welcome_edit" class="card-container">
        <div class="wx_in" :style="dataStyle" v-if="styleType === 'style1'">
            <a-textarea
                :placeholder="placeholder"
                :disabled="!textareaShow"
                v-model="data[changeParams[0]]"
                @change="
                    inputChange(changeParams[0], changeParams[1], changeParams[2], changeParams[3])
                "
                style="min-height: 100px;border: 0 none;background-color: inherit;resize:none;box-shadow: none;padding: 0;"
            />
            <div class="btn dir_right_nowrap cross_center" v-if="limitShow">
                {{ data[changeParams[2]] + '/' + [changeParams[1]] }}
                <a-button icon="user" type="link" style="margin-right: 5px;" @click="addName">
                    插入客户昵称
                </a-button>
            </div>
            <template v-if="materialBtnShow">
                <a-divider style="margin: 10px 0;" />
                <div v-if="!data.materialId">
                    <a-popover>
                        <template slot="content">
                            <div class="popover_list">
                                <ul class="main_between cross_center">
                                    <li
                                        class="dir_top_nowrap cross_center"
                                        @click="getMaterialList('text')"
                                        v-if="materialCate.text === 1"
                                    >
                                        <a-icon type="file-text" class="a_icon" />
                                        文 本
                                    </li>
                                    <li
                                        class="dir_top_nowrap cross_center"
                                        @click="getMaterialList('image')"
                                        v-if="materialCate.image === 1"
                                    >
                                        <a-icon type="picture" class="a_icon" />
                                        图 片
                                    </li>
                                    <li
                                        class="dir_top_nowrap cross_center"
                                        @click="getMaterialList('link')"
                                        v-if="materialCate.link === 1"
                                    >
                                        <a-icon type="link" class="a_icon" />
                                        网 页
                                    </li>
                                    <li
                                        class="dir_top_nowrap cross_center"
                                        @click="getMaterialList('wxapp')"
                                        v-if="materialCate.wxapp === 1"
                                    >
                                        <div class="jhgj_iconfont icon_Smallprogram a_icon"></div>
                                        小程序
                                    </li>
                                    <li
                                        class="dir_top_nowrap cross_center"
                                        @click="getMaterialList('file')"
                                        v-if="materialCate.file === 1"
                                    >
                                        <a-icon type="file" class="a_icon" />
                                        文 件
                                    </li>
                                </ul>
                            </div>
                        </template>
                        {{materialCate.name}}
                    </a-popover>
                </div>
                <div class="dir_left_wrap cross_center" v-else>
                    <div style="position: relative;">
                        <template v-if="data.mediaType === 'image' || data.mediaType === 'wxapp'">
                            <div class="upload_img">
                                <img :src="data.cover" width="80" height="80" />
                            </div>
                        </template>
                        <template v-else>
                            <div class="upload_text">
                                {{ data.title }}
                            </div>
                        </template>
                        <a-button
                            type="primary"
                            shape="circle"
                            icon="close"
                            class="upload_close"
                            size="small"
                            @click="uploadDel"
                        />
                    </div>
                </div>
            </template>
        </div>
        <div class="wx_in" :style="dataStyle" v-else-if="styleType === 'style2'">
            <div class="popover_list">
                <ul class="main_between cross_center">
                    <li
                        class="dir_top_nowrap cross_center"
                        @click="getMaterialList('text')"
                        v-if="materialCate.text === 1"
                    >
                        <a-icon type="file-text" class="a_icon" />
                        文 本
                    </li>
                    <li
                        class="dir_top_nowrap cross_center"
                        @click="getMaterialList('image')"
                        v-if="materialCate.image === 1"
                    >
                        <a-icon type="picture" class="a_icon" />
                        图 片
                    </li>
                    <li
                        class="dir_top_nowrap cross_center"
                        @click="getMaterialList('link')"
                        v-if="materialCate.link === 1"
                    >
                        <a-icon type="link" class="a_icon" />
                        网 页
                    </li>
                    <li
                        class="dir_top_nowrap cross_center"
                        @click="getMaterialList('wxapp')"
                        v-if="materialCate.wxapp === 1"
                    >
                        <div class="jhgj_iconfont icon_Smallprogram a_icon"></div>
                        小程序
                    </li>
                    <li
                        class="dir_top_nowrap cross_center"
                        @click="getMaterialList('file')"
                        v-if="materialCate.file === 1"
                    >
                        <a-icon type="file" class="a_icon" />
                        文 件
                    </li>
                </ul>
            </div>
        </div>
        <cModal
            :title="materialType + '素材选择'"
            :subName="{ modalName: 'materialModal' }"
            :visible="materialModal"
            backFunctionName="modalBtn"
            :backFunctionData="true"
            @modalBtn="modalBtn"
        >
            <materialList
                tableRowKey="id"
                tableTitle="title"
                :title="materialType + '列表'"
                :data="materialList"
                :page="materialPage"
                :params="materialParams"
                @backParams="backMaterialParams"
                @backSelect="backMaterialSelect"
            ></materialList>
        </cModal>
    </div>
</template>

<script>
import api from '@/apis';
import cModal from '@/components/common/ant/c_modal';
import materialList from '@/components/common/base/material_list';
export default {
    components: {
        cModal,
        materialList
    },
    props: {
        styleType: {
            type: String,
            default: 'style1'
        },
        data: {
            type: Object,
            default: function() {
                return {};
            }
        },
        dataStyle: {
            type: Object,
            default: function() {
                return {};
            }
        },
        changeParams: {
            type: Array,
            default: function() {
                return ['staffWelcomeDesc', 100, 'overWelcomeDescNum', 'overWelcomeDesc'];
            }
        },
        welcomeIntData: {
            type: Object,
            default: function() {
                return {};
            }
        },
        materialBtnShow: {
            type: Boolean,
            default: true
        },
        materialCate: {
            type: Object,
            default: function() {
                return {
                    // 文本
                    text: 0,
                    // 图片
                    image: 1,
                    // 网页
                    link: 1,
                    // 文件
                    file: 0,
                    // 小程序
                    wxapp: 0,
                    // 描述  添加图片/网页/小程序消息
                    name: '+ 添加图片/网页消息'
                };
            }
        },
        placeholder: {
            type: String,
            default: '设置个性化欢迎语，扫描码添加的客户，将自动推送该欢迎语'
        },
        limitShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 传递欢迎语
            welcomeData:
                this.welcomeIntData && Object.keys(this.welcomeIntData).length > 0
                    ? [this.welcomeIntData]
                    : [],
            materialList: [],
            materialParams: {
                mediaType: null,
                page: 1,
                categoryId: null
            },
            materialPage: {
                total: 0,
                pageSize: 10
            },
            materialType: null,
            materialModal: false,
            textareaShow: true,
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    watch: {},
    methods: {
        // 初始
        init() {
            if (this.data.content && this.data.content.length > 0) {
                this.welcomeData.push({
                    id: 1,
                    type: 'text',
                    info: this.data.content,
                    isShow: true
                });
            }
            if (this.data.mediaType) {
                this.welcomeData.push({
                    id:
                        this.data.mediaType === 'image'
                            ? 2
                            : this.data.mediaType === 'link'
                            ? 3
                            : 4,
                    type: this.data.mediaType,
                    info:
                        this.data.mediaType === 'image' || this.data.mediaType === 'wxapp'
                            ? this.data.cover
                            : (this.data.mediaType === 'link' ? (this.data.url ? this.data.url : this.data.title) : this.data.title),
                    isShow: true,
                    cover: this.data.cover ? this.data.cover : '',
                    description: this.data.description ? this.data.description : '',
                    title: this.data.title ? this.data.title : ''
                });
            }
            this.welcomeData.sort(this.welcomeDataSort('id'));
            this.$emit('backWelcomeData', this.welcomeData);
        },
        // 输入框变化
        inputChange(type, num, objsub1, objsub2) {
            const data = this.data;
            const textLength = data[type].length;
            if (this.data && type && num && objsub1 && objsub2) {
                if (textLength <= parseInt(num, 10)) data[objsub1] = textLength;
                if (textLength === parseInt(num, 10)) data[objsub2] = data[type];
                else if (textLength > parseInt(num, 10)) data[type] = data[objsub2];
            }
            if (type === this.changeParams[0]) {
                let currIndex;
                let arrAdd = true;
                this.welcomeData.forEach((item, index) => {
                    if (item.id === 1) {
                        item.info = data[type];
                        currIndex = index;
                        arrAdd = false;
                        return item;
                    }
                });

                // 当输入文字为0时，从welcomeData移除新插入元素
                if (textLength === 0 && (currIndex || currIndex === 0))
                    this.welcomeData.splice(currIndex, 1);
                if (arrAdd) {
                    this.welcomeData.push({
                        id: 1,
                        type: 'text',
                        info: data[type],
                        isShow: true
                    });
                }
            }
            this.welcomeData.sort(this.welcomeDataSort('id'));
            this.$emit('backTextarea', type, data[type], objsub2, data[objsub2]);
            this.$emit('backWelcomeData', this.welcomeData);
        },
        // 插入昵称
        addName() {
            if (this.data && this.data[this.changeParams[2]] <= this.changeParams[1] - 6) {
                let welcomeDesc = this.data[this.changeParams[0]];
                this.data[this.changeParams[0]] = (welcomeDesc ? welcomeDesc : '') + '#客户昵称#';
                this.inputChange(
                    this.changeParams[0],
                    this.changeParams[1],
                    this.changeParams[2],
                    this.changeParams[3]
                );
            } else {
                this.$message.error('最多可输入' + this.changeParams[1] + '个字');
            }
        },
        // 删除上传数据
        uploadDel() {
            this.data.materialId = null;
            this.data.materialType = null;
            this.data.cover = null;
            let welcomeIndex;
            this.welcomeData.forEach((item, index) => {
                if (item.id === 2 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) welcomeIndex = index;
            });
            this.welcomeData.splice(welcomeIndex, 1);
            this.textareaShow = true;
            this.welcomeData.forEach(item => {
                if (item.id === 1) item.isShow = true;
                return item;
            });
            this.welcomeData.sort(this.welcomeDataSort('id'));
            this.$emit('backWelcomeData', this.welcomeData);
            this.$emit('backCurrData', '');
        },
        // 获取素材列表
        async getMaterialList(mediaType) {
            if (!mediaType) return;
            this.materialType =
                mediaType === 'image' ? '图片' : mediaType === 'link' ? '网页' : mediaType === 'text' ? '文本' : mediaType === 'file' ? '文件' : '小程序';
            this.materialModal = !this.materialModal;
            this.materialParams.mediaType = mediaType;
            try {
                const res = await api.getMaterial(this.materialParams);
                if (res.code !== 0) return;
                res.rows.forEach((item) => {
                    item.isSelected = false;
                    return item;
                });
                this.materialList = res.rows;
                this.materialPage = {
                    total: res.count,
                    pageSize: res.pageSize
                };
            } catch (err) {
                console.log(err);
            }
        },
        // Modal是否展开
        modalBtn(subName) {
            this[subName.dataName.modalName] = !this[subName.dataName.modalName];
            if (subName.status) {
                this.materialList.forEach((item) => {
                    if (item.isSelected) {
                        this.data.mediaType = item.mediaType;
                        this.data.materialId = item.id;
                        this.data.cover = item.cover;
                        this.data.title = item.title;
                        this.welcomeData.push({
                            id: item.mediaType === 'image' ? 2 : item.mediaType === 'link' ? 3 : item.mediaType === 'text' ? 5 : item.mediaType === 'file' ? 6 : 4,
                            type: item.mediaType,
                            info:
                                item.mediaType === 'image' || item.mediaType === 'wxapp'
                                    ? item.cover
                                    : (item.mediaType === 'link' ? (item.url ? item.url : item.title) : item.title),
                            isShow: true,
                            cover: item.cover ? item.cover : '',
                            description: item.description ? item.description : '',
                            title: item.title ? item.title : ''
                        });
                        if (item.mediaType === 'text') {
                            // this.data[this.changeParams[0]] = item.title
                            this.textareaShow = false;
                            this.welcomeData.forEach(item => {
                                if (item.id === 1) item.isShow = false;
                                return item;
                            });
                        };
                        this.welcomeData.sort(this.welcomeDataSort('id'));
                        this.$emit('backWelcomeData', this.welcomeData);
                    }
                });
            }
        },
        // [欢迎语模板]获取子组件数据
        backMaterialParams(params) {
            this.materialParams = params;
            this.getMaterialList();
        },
        backMaterialSelect(currItem) {
            this.$emit('backCurrData', currItem);
        },
        // 欢迎语排序
        welcomeDataSort(property) {
            return function(obj1, obj2) {
                let value1 = obj1[property];
                let value2 = obj2[property];
                return value1 - value2;
            };
        }
    }
};
</script>

<style>
#wx_welcome_edit {
    margin-top: 0 !important;
}
#wx_welcome_edit .wx_in:hover {
    border-color:#1890ff !important;
}
#wx_welcome_edit .upload_img {
    border: 1px dashed #eee;
    position: relative;
    z-index: 0;
}
#wx_welcome_edit .upload_close {
    position: absolute;
    right: -10px;
    top: -10px;
    z-index: 1;
    transform: scale(0.8);
}
.popover_list {
    width: auto;
}
.popover_list ul {
    margin: 0;
}
.popover_list li {
    border: 1px solid #eee;
    border-radius: 3px;
    transition: all 0.3s ease 0s;
    font-size: 12px;
    line-height: 1.5;
    padding: 5px;
    width: 60px;
    cursor: pointer;
    margin: 0 4px;
}
.popover_list li:hover,
.popover_list li:hover .li_text {
    border-color: #ff5800;
    color: #ff5800;
}
.popover_list .a_icon {
    font-size: 20px;
    margin-bottom: 5px;
    height: 20px;
    line-height: 1;
}
</style>
